import { Component, OnInit } from '@angular/core';

@Component({
    template: require('./abastecimentos.component.html')
})
export class AbastecimentosComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/abastecimentos.component.ts
 **/